import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateEntityBudgetItemBody,
  EntityBudgetItemApi,
  FilterEntityBudgetItemOption,
  UpdateEntityBudgetItemBody,
} from 'api';

import { RootState } from '../app';

export const findEntityBudgetItemWithEntity = createAsyncThunk(
  'entityBudgetItem/findEntityBudgetItemWithEntity',
  async (option: FilterEntityBudgetItemOption, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetItemApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityBudgetItem = createAsyncThunk(
  'entityBudgetItem/filterEntityBudgetItem',
  async (option: FilterEntityBudgetItemOption, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetItemApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityBudgetItem = createAsyncThunk(
  'entityBudgetItem/findOneEntityBudgetItem',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await EntityBudgetItemApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityBudgetItem = createAsyncThunk(
  'entityBudgetItem/createEntityBudgetItem',
  async (body: CreateEntityBudgetItemBody, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetItemApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityBudgetItem = createAsyncThunk(
  'entityBudgetItem/updateEntityBudgetItem',
  async (
    params: {
      id: string;
      body: UpdateEntityBudgetItemBody;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityBudgetItemApi.update(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityBudgetItem = createAsyncThunk(
  'entityBudgetItem/removeEntityBudgetItem',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityBudgetItemApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const entityBudgetItemSlice = createSlice({
  name: 'entityBudgetItem',
  initialState,
  reducers: {},
});

const { reducer: entityBudgetItemReducer } = entityBudgetItemSlice;

export default entityBudgetItemReducer;

export const selectEntityBudgetItem = (state: RootState): IState =>
  state.entityBudgetItem as IState;
